import { Dashboard } from './Dashboard';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { NavigationAppBar } from 'src/common/components/AppLayout/AppNavigation/Components/NavigationAppBar';
import { useTranslation } from 'react-i18next';
import { DashboardAccountSelect } from './Componets/DashboardAccountSelect';
import { TablePageTitle } from 'src/common/components/AppLayout/TablePage/TablePageTitle';
import { SomethingWentWrongErrorBoundary } from 'src/common/components/Fallbacks/SomethingWentWrongErrorBoundary';
import { DashboardURLParser } from './DashboardURLParser';

const DashboardTitleAccountSelector = styled('div')({
  display: 'flex',
  flex: '1',
  justifyContent: 'center',
});

export const DashboardPage = () => {
  const { t } = useTranslation();

  return (
    <DashboardURLParser>
      <SomethingWentWrongErrorBoundary>
        <Box
          sx={{
            marginBottom: 12,
          }}
        >
          <NavigationAppBar
            title={<TablePageTitle>{t('dashboard.title')}</TablePageTitle>}
            middleContent={
              <DashboardTitleAccountSelector>
                <DashboardAccountSelect />
              </DashboardTitleAccountSelector>
            }
          />
        </Box>
        <Box>
          <Dashboard />
        </Box>
      </SomethingWentWrongErrorBoundary>
    </DashboardURLParser>
  );
};
